import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  careers: [],
  careerResult: {},
  programAlumniData: {},
  showAllOccupations: false
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/programguide/vuex/index.js